/**
 * Narrows `unknown` to a non-null, non-array `object` for property probing.
 *
 * Intentionally does not exclude built-ins like `Date`, `Map`, class instances,
 * or `Object.create(null)` — this is a fast preliminary check meant to be
 * followed by explicit field-shape validation on the caller side (see
 * `hasRequiredStrings` in `inputValidation.ts`). If you need a strict
 * "true POJO only" check, do the prototype comparison at the call site.
 */
export function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

export function isBoolean(value: unknown): value is boolean {
  return typeof value === 'boolean';
}

export function isNonEmptyString(value: unknown): value is string {
  return isString(value) && value.length > 0;
}

export function isOptional<T>(value: unknown, isType: (v: unknown) => v is T): value is T | undefined {
  return value === undefined || isType(value);
}
